import React from "react";


const RequestsSpotMapCreationStatus = ({status}) => {

  const statusIcons = {
    'not-requested': null, // Geen actie nodig, geen icoon
    'pending': <span title="Aangevraagd door klant, gaat instructiemail krijgen">⏳</span>,
    'instructions-sent-to-client': <span title="Instructiemail verstuurd, wachten op details van klant">📩</span>,
    'completed': <span title="Voltooid">✅</span>,
    'flagged-by-admin': <span title="Gemarkeerd door admin als ongeschikt">⚠️</span>,
    'take-over-suggestion-sent': <span title="Overname voorgesteld aan klant">🤝</span>,
    'not-interested': <span title="Klant heeft geen interesse">🚫</span>,
  };

  return (
    <>{statusIcons[status] &&
      <span>{statusIcons[status]}</span>
      }
    </>
  )
}

export default RequestsSpotMapCreationStatus